/* eslint-disable indent */
//all the routes.
export const HOME = "/";
export const LOGIN = "/login";
export const ADMIN_DASHBOARD = "/dashboard";
export const ADMIN_BATCHES = "/batches";
export const ADMIN_USERS = "/users";
export const ADMIN_USER_QUERIES = "/queries";
export const ADMIN_COURSES = "/courses";
export const ADMIN_SALES = "/sales";
export const ADMIN_ADMIN_MANAGEMENT = "/admin-management";
export const ADMIN_CONFIG_MANAGEMENT = "/config-management";
export const NOT_FOUND = "*";
export const COURSE_MANAGEMENT_ROUTE_PREFIX = "/courses/manage";
export const COURSE_MANAGEMENT_MENU_ROUTE = "/courses/manage-menu";
export const FORTY_FIVE_DAYS_OF_CODE_CONTEST = "/45-days-of-code/contests";
export const FORTY_FIVE_DAYS_OF_CODE_ENROLLMENTS = "/45-days-of-code/enrollments";
export const DISCORD_ANALYTICS_QUERY_ANALYTICS = "/discord-analytics/queries-analytics";
export const DISCORD_ANALYTICS_QUERIES_DASHBOARD = "/discord-analytics/queries";
export const DISCORD_ANALYTICS_EXPENSE_ANALYSIS = "/discord-analytics/mentors/expense-analysis";
export const DISCORD_ANALYTICS_MENTOR_PERFORMANCE = "/discord-analytics/mentors/performance";
export const DISCORD_ANALYTICS_MENTOR_DATA = "/discord-analytics/mentors/data";
export const CP_SHEET_PROBLEMS = "/cp-sheet/problems";
export const ADMIN_EDUCATOR_MANAGEMENT = "/educator-management";
export const ADMIN_REFERRAL_DASHBOARD = "/referral-dashboard";
export const SURVEY_SYSTEM_DASHBOARD = "/survey-dashboard";
export const BULK_NOTIFICATIONS_MAILING_LISTS = "/bulk-notifications/mailing-lists";
export const BULK_NOTIFICATIONS_CAMPAIGNS = "/bulk-notifications/campaigns";
export const BULK_NOTIFICATIONS_MAILING_ASSETS = "/bulk-notifications/mailing-assets";
export const CP_SHEET_ANALYTICS_GENERAL = "/cp-sheet/analytics/general";
export const CP_SHEET_ANALYTICS_PROBLEM = "/cp-sheet/analytics/problem";
export const CP_SHEET_ANALYTICS_USER = "/cp-sheet/analytics/user";
export const CP_SHEET_COMMENT_MODERATION = "/cp-sheet/comment-moderation";
export const CP_SHEET_LEADERBOARD = "/cp-sheet/leaderboard";
export const WEBSITE_BLOGS_STATISTICS = "/cp-digest/statistics";
export const WEBSITE_BLOGS_MANAGEMENT = "/cp-digest/management";
export const PAYMENTS_DISCOUNT_MANAGEMENT = "/payments/discounts";
export const PAYMENTS_LEADS = "/payments/leads";
export const GLOBAL_CONTESTS_MANAGEMENT = "/global-contests";
export const PCD_SNIPPETS_MANAGEMENT = "/global-contests/pcd-snippets";
export const WEBSITE_ANNOUNCEMENTS_MANAGEMENT = "/website-announcements";
export const COURSE_ANALYTICS = "/course-analytics";
export const COURSE_MODULES_MANAGEMENT = "/course-content/management";
export const COURSE_MODULES_LINKING = "/course-content/module-linking";
export const COURSE_CONTEST_MANAGEMENT = "/course-content/contest-management";
export const LOGOUT = "/logout";
export const CAREERS_MANAGEMENT = "/careers-management";
export const COURSE_SESSIONS_MANAGEMENT = "/course-sessions";
export const ADMIN_GUIDANCE_SESSIONS = "/guidance-sessions";
export const WEBSITE_MENTORS_MANAGEMENT = "/website-mentors";
export const WEBSITE_TESTIMONIALS_MANAGEMENT = "/website-testimonials";
export const WAITLIST_MANAGEMENT = "/waitlist";
export const WEBSITE_FEATURED_PROFILES_MANAGEMENT = "/website-profiles";
export const EXTERNAL_PROBLEMS_MANAGEMENT = "/external-problems";
export const TAG_MAPPINGS = "/tag-mappings";
export const REWARD_KIT_CLAIMS = "/reward-kit-claims";

export const envOptions = [
  {
    label: "Development",
    value: "dev"
  },
  {
    label: "Staging",
    value: "staging"
  },
  {
    label: "Production",
    value: "production"
  }
];

const DEV_ROOT_URL = "http://api.lvh.me:8080";

export const backendUrlByEnv = (env) => {
  // eslint-disable-next-line keyword-spacing
  switch (env) {
    case "dev":
      return DEV_ROOT_URL;
    case "staging":
      return process.env.REACT_APP_BACKEND_STAGING_URL;
    case "production":
      return process.env.REACT_APP_BACKEND_PRODUCTION_URL;
  }
};
